// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-2DRNc","title":"title-2juu_","description":"description-v6CKU","icon_wrapper":"icon_wrapper--yHoF"};